import { useContext } from "react"
import * as React from "react"
import { Context } from "../../../store/store"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	formElementChanged: Function
	validation: Object
}
const MafoQuestionSeven: React.FC<MafoQuestionProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	return (
		<>
			<h3 className="mb-2 text-center font-Alpro  text-[24px] text-blue lg:text-center lg:text-[32px]">Würdest Du das Alpro Produkt wieder kaufen?</h3>
			<div className="mx-auto grid grid-cols-1 flex-row text-left lg:max-w-[75%]">
				<ElemCheckboxMafo
					label={<>Sehr wahrscheinlich</>}
					props={{
						type: "radio",
						name: "question7",
						value: "a",
						onClick: e => formElementChanged(e, "question7"),
					}}
					hasError={validation["invalid_question7"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question7_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Eher wahrscheinlich</>}
					props={{
						type: "radio",
						name: "question7",
						value: "b",
						onClick: e => formElementChanged(e, "question7"),
					}}
					hasError={validation["invalid_question7"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question7_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Eher unwahrscheinlich</>}
					props={{
						type: "radio",
						name: "question7",
						value: "c",
						onClick: e => formElementChanged(e, "question7"),
					}}
					hasError={validation["invalid_question7"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question7_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Sehr unwahrscheinlich</>}
					props={{
						type: "radio",
						name: "question7",
						value: "d",
						onClick: e => formElementChanged(e, "question7"),
					}}
					hasError={validation["invalid_question7"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question7_errMsg"] || ""}
				/>
			</div>
		</>
	)
}

export default MafoQuestionSeven
